export const BOOK = "book/book";
export const DELETE = "book/delete";